import React, { useEffect } from 'react';

const WeatherWidget = ({cityId}) => {
  useEffect(() => {
    window.myWidgetParam=window.myWidgetParam ? window.myWidgetParam : window.myWidgetParam = [];
    window.myWidgetParam.push({ id: 11, cityid: cityId, appid: '3c9ef517498e203e52b4ba3db5274793', units: 'metric', containerid: 'openweathermap-widget-11',lang: 'zh' });
    (function () {
      var script = document.createElement('script'); script.async = true; script.charset = "utf-8";
      script.src = "//openweathermap.org/themes/openweathermap/assets/vendor/owm/js/weather-widget-generator.js";
      var s = document.getElementsByTagName('script')[0];
      s.parentNode.insertBefore(script, s);
    })();
  }, []);
  return (
    <div id="openweathermap-widget-11"></div>
  );
};

export default WeatherWidget;
